export enum ProductCatalogViewType {
  TILE = "tile view",
  LIST = "list view",
}
